import axios from 'axios'
import { toastr } from 'react-redux-toastr'

import { URL } from '../../assets/js/constants'

function carregarCupons(data) {
    return {
        type: 'CUPONS_FETCHED',
        payload: data
    }
}

function carregarCupom(data) {
    return {
        type: 'CUPOM_FETCHED',
        payload: data
    }
}

function cupomLoading(data) {
    return {
        type: 'CUPOM_LOADING',
        payload: data
    }
}

function cupomProcessing(data) {
    return {
        type: 'CUPOM_PROCESSING',
        payload: data
    }
}

export function getCupomDeDesconto(value) {
    return dispatch => {
        dispatch(cupomLoading(true));
        axios.get(`${URL}/cupons/${value}`)
            .then(resp => {
                dispatch(carregarCupom(resp.data));
                dispatch(cupomLoading(false));
            })
            .catch(e => {
                dispatch(cupomLoading(false));
                toastr.error('Erro', e.message);
            })
    }
}

export function getCuponsDoNegocio(idNegocio) {
    return dispatch => {
        axios.get(`${URL}/cupons/negocio/${idNegocio}`)
            .then(resp => {
                dispatch(carregarCupons(resp.data));
            })
            .catch(e => {
                toastr.error('Erro', e.message);
            })
    }
}

export function getCupons() {
    return dispatch => {
        axios.get(`${URL}/cupons`)
            .then(resp => {
                dispatch(carregarCupons(resp.data));
            })
            .catch(e => {
                toastr.error('Erro', e.message);
            })
    }
}

export function addCupomDeDesconto(data) {
    return dispatch => {
        dispatch(cupomProcessing(true));
        axios.post(`${URL}/cupons`, data)
            .then(resp => {
                dispatch(carregarCupom(resp.data));
                dispatch(toastr.success('Sucesso', 'Cupom de desconto cadastrado com sucesso.'));
                dispatch(cupomProcessing(false));
            })
            .catch(e => {
                dispatch(cupomProcessing(false));
                try {
                    const data = e.response.data;
                    if (typeof data !== 'undefined') {
                        const { status, msg, errors } = data;
                        if (status === 400) {
                            errors.forEach(erro => {
                                toastr.error(msg, 'Campo: ' + erro.fieldName + '. ' + erro.message);
                            })
                        } else {
                            toastr.error(msg, 'Erro: ' + status);
                        }
                    }
                } catch (e) {
                    return false;
                }
            })
    }
}

export function editCupomDeDesconto(data) {
    return dispatch => {
        dispatch(cupomProcessing(true));
        axios.put(`${URL}/cupons`, data)
            .then(resp => {
                dispatch(toastr.success('Sucesso', 'Cupom de desconto atualizado com sucesso.'));
                dispatch(cupomProcessing(false));
            })
            .catch(e => {
                dispatch(cupomProcessing(false));
                try {
                    const data = e.response.data;
                    if (typeof data !== 'undefined') {
                        const { status, msg, errors } = data;
                        if (status === 400) {
                            errors.forEach(erro => {
                                toastr.error(msg, 'Campo: ' + erro.fieldName + '. ' + erro.message);
                            })
                        } else {
                            toastr.error(msg, 'Erro: ' + status);
                        }
                    }
                } catch (e) {
                    return false;
                }
            })
    }
}

export function deletarCupomDeDesconto(value) {
    return dispatch => {
        dispatch(cupomProcessing(true));
        axios.delete(`${URL}/cupons/${value.id}`)
            .then(_ => dispatch(getCuponsDoNegocio(value.idNegocio)))
            .then(_ => dispatch(toastr.success('Sucesso', 'Cupom de desconto excluído com sucesso!')))
            .catch(e => {
                dispatch(cupomProcessing(false));
                try {
                    const { msg } = e.response.data;
                    toastr.error('Erro', msg);
                } catch (e) {
                    return false;
                }
            }
            )
    }
}